module.exports = __webpack_public_path__ + "static/media/Meadowbrook-Lake.478ba620.pdf";